module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/icon_case02-321a1d4e52d39f3fe11537504c2c94e6.svg";